import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaStar, FaRegStar, FaStarHalfAlt } from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import { FaBriefcaseMedical } from "react-icons/fa";
import { IoMdCall } from "react-icons/io";
import { FaLanguage } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaStethoscope } from "react-icons/fa6";
import { TbChevronsDownLeft, TbStarsFilled } from "react-icons/tb";
import { BsCashCoin } from "react-icons/bs";
import { RiSpeakFill } from "react-icons/ri";
import { FaLocationDot } from "react-icons/fa6";

import ServiceSection from "../HomePageElements/ServiceSection";
import ConsultSection from "../HomePageElements/ConsultSection";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./DoctorsGridPageCss/DoctorSeparatePage.css";
import doctors from "../../DB/DoctorsDetails";
import SeperateImageSection from "./SeperatePageFirstSection";
import { TiArrowBack } from "react-icons/ti";
import { FaUserTie } from "react-icons/fa";
import { getDoctorInfo, getDoctorList } from "../../api/api";
import { grey } from "@mui/material/colors";
import doctorDefault from "../../Assets/doctor_default_copy.jpeg";
import { toCamelCase } from "../../utils/helper";

const PatientTestimonials = ({ stories = [] }) => {
  // If no stories, render nothing (parent handles fallback message)
  if (!stories || stories.length === 0) return null;

  // If only one story, render it statically to avoid Slick cloning the slide
  if (stories.length === 1) {
    const storyObj = stories[0];
    return (
      <div className="patient-testimonials">
        <h3>Patient Testimonials</h3>
        <div className="testimonial-card">
          <blockquote>
            {storyObj.feedbackDate && (
              <span
                style={{
                  display: "block",
                  fontSize: "0.8rem",
                  color: "#666",
                  marginTop: 6,
                }}
              >
                {new Date(storyObj.feedbackDate).toLocaleDateString()}
              </span>
            )}
            <div style={{ marginTop: 8 }}>“{storyObj.patientStory}”</div>
            <footer>— {storyObj.patientName}</footer>
          </blockquote>
        </div>
      </div>
    );
  }

  const slidesToShow = Math.min(2, stories.length);
  const settings = {
    dots: true,
    infinite: stories.length > slidesToShow,
    autoplay: stories.length > 1,
    autoplaySpeed: 4000,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: Math.min(1, stories.length) },
      },
    ],
  };


  return (
    <div className="patient-testimonials">
      <h3>Patient Testimonials</h3>
      <Slider {...settings}>
        {stories.map((storyObj, idx) => (
          <div key={idx} className="testimonial-card">
            <blockquote>
              {storyObj.feedbackDate && (
                <span
                  style={{
                    display: "block",
                    fontSize: "0.8rem",
                    color: "#666",
                    marginTop: 6,
                  }}
                >
                  {new Date(storyObj.feedbackDate).toLocaleDateString()}
                </span>
              )}
              <div style={{ marginTop: 8 }}>“{storyObj.patientStory}”</div>
              <footer>— {storyObj.patientName}</footer>
            </blockquote>
          </div>
        ))}
      </Slider>
    </div>
  );
};

const DoctorSeparatePage = () => {
  const location = useLocation();
  const doctorFromState = location.state?.doctor;
  const { doctorSlug } = useParams();
  const id = doctorSlug;
  const [doctor, setDoctor] = useState(null);
  const navigator = useNavigate();
  const [ratingData, setRatingData] = useState([]);

  const normalizeDoctorKey = (value = "") =>
    value
      .toLowerCase()
      .trim()
      .replace(/[().]/g, "")
      .replace(/[_\s]+/g, "-")
      .replace(/-+/g, "-");

  useEffect(() => {
    if (doctorFromState) {
      setDoctor(doctorFromState);
    } else {
      fetchDoctorData();
    }
    getDoctorRatingData();
  }, []);
  console.log("Doctor data in separate page:", doctor);

  const fetchDoctorData = async () => {
    try {
      const res = await getDoctorList();

      if (res?.data?.data) {
        // const filteredDoctorData = res.data.data.filter(
        //   (doc) => String(doc.doctor_id) === String(id)
        // );

        const filteredDoctorData = res.data.data.filter(
          (doc) => normalizeDoctorKey(doc.doctor_name) === normalizeDoctorKey(doctorSlug)
        );

        console.log("Id found in the data: ", filteredDoctorData);

        if (filteredDoctorData.length > 0) {
          const doctorObj = filteredDoctorData[0];
          // localStorage.setItem("doctorDetails", JSON.stringify(doctorObj));
          setDoctor(doctorObj);
        } else {
          console.log("Doctor not found for id:", id);
        }
      }
    } catch (error) {
      console.error("Error fetching doctor data:", error);
    }
  };

  const getDoctorRatingData = async () => {
    try {
      const res = await getDoctorInfo({ doctorId: id });
      console.log("Doctor rating data response:", res);
      if (res?.data?.status === "Success") {
        setRatingData(res?.data?.doctorRating || []);
      }
    } catch (error) {
      console.error("Error fetching doctor rating data:", error);
    }
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={i} color="#FFD700" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" color="#0ca798" />);
    }
    while (stars.length < 5) {
      stars.push(<FaRegStar key={`empty-${stars.length}`} color="#ccc" />);
    }
    return stars;
  };
  const patientStories =
    Array.isArray(ratingData) &&
      ratingData.length > 0 &&
      Array.isArray(ratingData[0]?.patientStories)
      ? ratingData[0].patientStories
      : [];

  if (!doctor) {
    return (
      <div className="doctor-details-skeleton">
        <div className="skeleton-avatar" />
        <div className="skeleton-header" />
        <div className="skeleton-subtitle" />
        <div className="skeleton-paragraph" />
        <div className="skeleton-paragraph short" />
      </div>
    );
  }

  const handleBookAppointment = (doctorInfo) => {
    console.log(doctorInfo);

    navigator("/appointment/date-and-time", { state: { doctor: doctorInfo } });
  };

  const handleGoBack = () => {
    navigator('/doctors-grid');
  };

  return (
    <>
      <SeperateImageSection />

      <div className="doctor-profile-page">
        <div className="separate-doctor-container">
          <div className="doctor-basic-info">
            <div className="doctor-img-spe">
              <button className="back-btn" onClick={handleGoBack}>
                <TiArrowBack size={22} style={{ marginRight: "8px" }} />{" "}
                <span className="btn-text">Back</span>
              </button>
              {doctor.DoctorPictureUrl ? (
                <img
                  src={doctor.DoctorPictureUrl}
                  alt={doctor.name}
                  className="separate-doctor-img"
                />
              ) : (
                <div className="placeholder-doctor-img">
                  <img
                    src={doctorDefault}
                    alt="Default Doctor"
                    className="separate-doctor-img"
                  />
                </div>
              )}

              {/* <h1>{doctor.name} <MdVerified color="rgb(76 155 224)" /></h1>
                            <p><FaStethoscope style={{ color: "rgb(24, 79, 123)" }} /> {doctor.specialty}</p> */}
              <div className="doctorDetailsUpperButton">
                <button
                  className="bookAppointmentBtn rbdButton bookprofile"
                  onClick={() => handleBookAppointment(doctor)}
                >
                  <span className="btn-text">BOOK APPOINTMENT</span>
                </button>
              </div>
            </div>

            <div className="details-doctor-temp">
              <h2 style={{ color: grey }}>
                Dr. {toCamelCase(doctor?.doctor_name)}{" "}
                {doctor?.doctorVerificationStatus && (
                  <MdVerified color="rgb(76 155 224)" />
                )}
              </h2>
              <p>
                <FaStethoscope style={{ color: "rgb(24, 79, 123)" }} />{" "}
                {doctor.specialization}
              </p>

              <p>
                <FaUserTie
                  style={{ marginRight: "0.5rem", color: "#106E4F" }}
                />
                {doctor.Designation}
              </p>

              {/* <p><FaLocationDot style={{ color: "rgb(58, 145, 116)" }} />{doctor?.centers.map(center => center.center_name).join(", ")}</p> */}
              <p>
                <BsCashCoin style={{ color: "rgb(194, 80, 31)" }} />{" "}
                <strong
                  style={{
                    marginLeft: "10px",
                    fontSize: "1.3rem",
                    color: "#0CA798",
                  }}
                >
                  ₹{doctor?.centers?.[0]?.Fees || 0}/-
                </strong>{" "}
                Consultant Fee
              </p>

              <div className="review-Div">
                {renderStars(Number(doctor.avgRating))}{" "}
                <span style={{ marginLeft: "0.5rem" }}>
                  {Number(doctor.avgRating)} Ratings
                </span>
              </div>
              {doctor.experience > 0 ? (
                <p>
                  <TbStarsFilled
                    style={{ marginRight: "0.5rem", color: "rgb(141, 77, 75)" }}
                  />
                  {doctor.experience} years experience
                </p>
              ) : (
                ""
              )}

              {/* <p><RiSpeakFill style={{ marginRight: "0.5rem", color: "rgb(24, 79, 123)" }} />Languages: {doctor.languages.join(", ")}</p> */}
            </div>
          </div>

          <div className="doctorAboutSection">
            <div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "0.5rem",
                  marginTop: "0",
                  color: "#184f7b",
                }}
              >
                About
              </h3>
              <p style={{ lineHeight: "1.2" }}>{doctor?.AboutDoctor || "NA"}</p>

              {doctor.Training && (
                <div style={{ marginBottom: "2rem", marginTop: "1rem" }}>
                  <h3 style={{ fontSize: "1.3rem", color: "#184f7b" }}>
                    Education & Training
                  </h3>
                  <p style={{ lineHeight: "1.2" }}>{doctor?.Training}</p>
                </div>
              )}
              {/* <h3 style={{ fontSize: "1.3rem", marginTop: "1rem", color: "#184f7b" }}>Education & Training</h3>
                            <p style={{ lineHeight: "1.2" }}>{doctor?.Training}</p> */}
            </div>

            {/* <div style={{ marginBottom: "2rem" }}>
                            <h3 style={{ fontSize: "1.3rem", color: "#184f7b" }}>Available Days</h3>
                            <p>{doctor.availableDays.join(", ")}</p>
                        </div> */}
            {doctor.Awards?.length > 0 && (
              <div style={{ marginBottom: "2rem" }}>
                <h3 style={{ fontSize: "1.3rem", color: "#184f7b" }}>
                  Awards & Recognition
                </h3>
                <p>{doctor.Awards || "NA"}</p>
              </div>
            )}
          </div>
        </div>

        <div className="patientStoriesDiv">
          {patientStories.length > 0 ? (
            <PatientTestimonials stories={patientStories} />
          ) : (
            <div style={{ padding: "1.2rem 0" }}>
              <h3 style={{ fontSize: "1.2rem" }}>Patient Testimonials</h3>
              <p>No patient stories available for this doctor.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DoctorSeparatePage;
